import styled from 'styled-components';

const StyledTitle = styled.div`
    color: ${({color}) => color ? color : "var(--sp-text-color)"};
    font-weight: 600;
    font-size: ${props =>
        props.h1 ? '32px' : props.h2 ? '28px' : props.h3 ? '24px' : props.h4 ? '20px' : props.h5 ? '18px' : props.h6 ? '16px' : '14px'
    };
    line-height: ${props =>
        props.h1 ? '40px' : props.h2 ? '34px' : props.h3 ? '32px' : props.h4 ? '28px' : props.h5 ? '24px' : props.h6 ? '22px' : '18px'
    };
    margin: ${({margin}) => margin && `${margin.top || 0} ${margin.right || 0} ${margin.bottom || 0} ${margin.left || 0} `};
    text-transform: ${({ capitalize }) => capitalize && "capitalize" };
    max-width: ${({max}) => max};
    white-space: ${({max, nowrap}) => (max || nowrap) && "nowrap"};
    overflow: ${({max}) => max && "hidden"};
    text-overflow: ${({max}) => max && "ellipsis"};
`;

const StyledParagraph = styled.span`
    font-size: ${({size}) => size || '14px'};
    line-height: ${({lineHeight}) => lineHeight || '135%'};
    font-weight: ${({bold}) => bold ? "600" : undefined};
    font-style: ${({italic}) => italic ? "italic" : "normal"};
    color: ${props => props.blur ? '#8898B2' : props.color ? props.color : 'var(--sp-text-color)'};
    margin: ${({margin}) => margin && `${margin.top || 0} ${margin.right || 0} ${margin.bottom || 0} ${margin.left || 0} `};
    max-width: ${({maxWidth}) => maxWidth};
    white-space: ${({nowrap}) => nowrap && "nowrap"};
    overflow: ${({nowrap}) => nowrap && "hidden"};
    text-overflow: ${({nowrap}) => nowrap && "ellipsis"};

    word-break: ${({breakWord}) => breakWord ? "break-word" : undefined};
    white-space: ${({whiteSpace}) => whiteSpace};

    &[disabled] {
        color: rgba(0, 0, 0, .25);
    }

    & code {
        padding: 4px;
        font-family: 'Cousine', monospace;
        background: var(--sp-light-blue-color);
    }
`;

const StyledLabel = styled.label`
    font-size: ${({size}) => size || '12px'};
    line-height: ${({lineHeight}) => lineHeight || '135%'};
    font-weight: ${({bold}) => bold && 600};
    text-transform: ${({ textTransform }) => textTransform || "uppercase"};
    color: ${({color}) => color ? color : "var(--sp-label-color)"};
    white-space: nowrap;
    background: ${({filled, fill}) => filled ? fill ? fill : "var(--sp-light-grey-blue-color)" : "unset"};
    padding:  ${({filled}) => filled ? "2px 10px" : "unset"};
    border-radius:  ${({filled}) => filled ? "4px" : "unset"};

    ${({ required }) => required &&
        `&::before {
            content: "*";
            color: var(--sp-error-color);
            margin-inline-end: 4px;
        }`}
`;

export const StyledLoadingText = styled.div`
    min-height: ${({height}) => height || "14px"};
    width: ${({width}) => width || "150px"};
    border-radius: ${({radius}) => radius};
    background: linear-gradient(-45deg, #E0E8F9 23%, rgba(256, 256, 256, .1) 37%, #E0E8F9 59%);
    background-size: 400% 100%;
    animation: loading 3s ease 0s infinite normal none;

    @-webkit-keyframes loading {
        0% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0 50%;
        }
    }

    @keyframes loading {
        0% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0 50%;
        }
    }
`;

export const LoadingCircle = (props) => <StyledLoadingText height="32px" width="32px" radius="100px" />

export const Title = ({ isLoading, width, ...props}) => {
    return(
        isLoading
            ? <StyledLoadingText
                height={props.h1 ? '40px' : props.h2 ? '34px' : props.h3 ? '32px' : props.h4 ? '28px' : props.h5 ? '24px' : props.h6 ? '22px' : '18px' }
                width={width}
            />
            : <StyledTitle {...props} />
    )
};

export const Paragraph = (props) => {
    return(
        props.isLoading
            ? <StyledLoadingText height={props.lineHeight ? props.lineHeight : "18px"} width={props.width} />
            : <StyledParagraph {...props} />
    )
};

export const Label = (props) => <StyledLabel {...props} />

const StyledCopyright = styled.span`
    font-size: 12px;
    line-height: 1.5em;
    color: var(--sp-text-grey-color);
`;

export const Copyright = (props) => <StyledCopyright {...props} />;

export const FilledLabel = (props) => <StyledLabel filled color="var(--sp-paragraph-color)" size="13px" bold {...props} />